import React, { ReactNode } from 'react'
import { Box } from '@mui/material'
import { LAYOUT_SPACING } from '../../constants/layout'

/**
 * Props for SidebarNavigation
 */
export interface SidebarNavigationProps {
  children: ReactNode
}

/**
 * SidebarNavigation - Navigation container for the sidebar menu
 *
 * Wraps the menu list with proper padding and scroll behavior.
 */
export const SidebarNavigation: React.FC<SidebarNavigationProps> = ({ children }) => {
  return (
    <Box
      component="nav"
      sx={{
        flex: 1,
        padding: `${LAYOUT_SPACING.SIDEBAR_CONTAINER_PADDING}px`,
        overflowY: 'auto'
      }}
    >
      {children}
    </Box>
  )
}
